<template>
  <div>
    <van-popup
      v-model="isShow"
      class="full-width"
      position="right"
      :close-on-popstate="true"
    >
      <ld-navbar
        @click-left="toggle"
      >
        <van-search
          placeholder="请输入搜索关键词"
          v-model="value"
          @clear="getList(1)"
        />
      </ld-navbar>

      <div class="deptwrapper">
        <mescroll-vue
          ref="mescroll"
          :down="{}"
        >
          <div class=" pad-6">
            <van-row class="font16 font-lg text-center">   
              <van-col span="12">
                当前部门
              </van-col>
              <van-col span="12">
                上级部门
              </van-col>
            </van-row>   
            <van-cell
              class="font14"
              v-for="info in depobj"
              :key="info.id"
              @click.native="$emit('selected', info)"
              :title="info.vipdeptName"
            >
              <div class="text-left">
                {{ info.parDeptName }}
              </div>
            </van-cell>
          </div>
        </mescroll-vue>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Popup ,Search,Cell} from 'vant'
import MescrollVue from 'mescroll.js/mescroll.vue'
import ldNavbar from 'Common/ldNavbar'

export default {
  name:'DeptList',
  components: {
    [Popup.name]: Popup,
    [Search.name]: Search,
    [Cell.name]: Cell,
    MescrollVue,
    ldNavbar
  },
  data () {
    return {
      value:'',
      depobj:{},
      isShow:false
    }
  },
  methods:{
    getList(val){
      this.$api['emp/vipDeptFindList']({
        'deptName':val,
        'count': 999,
        'pageNum': 1
      }).then(res => {
        let cache = res.data || {}
        this.depobj=cache.list||[]
      })
    },
    toggle(){
      this.isShow =!this.isShow
      if(this.isShow){
        this.getList()
      }
    }
  },
  watch: {
    value(val){//检索
      this.getList(val)
    }
  }
}
</script>

<style  lang="less" scoped>
    .deptwrapper {
        height: calc(100vh - 54px);
        overflow: hidden;
    }
    .pad-6{
        padding: 6px;
    }
</style>
